/* eslint-disable @typescript-eslint/no-explicit-any */
// @ts-nocheck
import React from 'react';
import { t } from '../../../locales/i18n';
import { callNext, callAgain, callPrevious } from '../index';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';
import styled from 'styled-components';
import { sizes } from '../../../themes/sizes';
import { breakpoints } from '@nextinq/ui-toolkit';

const Container = styled.section`
  display: grid;
  gap: ${sizes.margins.normal};
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-template-areas:
    '  next  next  '
    'previous again';
  .btn-next {
    grid-area: next;
  }
  .btn-previous {
    grid-area: previous;
  }
  .btn-again {
    grid-area: again;
  }
  @media ${breakpoints.max.smallPhone} {
    grid-template-columns: 1fr 1fr 1fr;

    grid-template-rows: 1fr;
    grid-template-areas: 'previous next again';
    button.ui {
      font-size: 13px;
    }
  }
`;

export interface QueueActionsProps {
  onCallNext: (queueId: string) => void;
  onCallPrevious: (queueId: string) => void;
  onCallAgain: (queueId: string) => void;
}

export function $QueueActions(props: QueueActionsProps) {
  return (
    <Container>
      <Button primary className="btn-next" onClick={() => props.onCallNext(props.id)}>
        {t('queueActions.callNext')}
      </Button>
      <Button className="btn-previous" onClick={() => props.onCallPrevious(props.id)}>
        {t('queueActions.callPrevious')}
      </Button>
      <Button className="btn-again" onClick={() => props.onCallAgain(props.id)}>
        {t('queueActions.callAgain')}
      </Button>
    </Container>
  );
}

const mapDispatchToProps = (dispatch) => ({
  onCallNext: (queueId) => dispatch(callNext(queueId)),
  onCallAgain: (queueId) => dispatch(callAgain(queueId)),
  onCallPrevious: (queueId) => dispatch(callPrevious(queueId))
});

export const QueueActions = connect(null, mapDispatchToProps)($QueueActions);
